module.exports = __webpack_public_path__ + "static/media/waste-div-icon.137a514f.png";